import React from "react";
import {Route, Routes} from "react-router-dom";
import {SettingsView} from "../views";

const SettingsRoutes = () => {
    return (
        <Routes>
            <Route path="/" element={<SettingsView/>}/>
        </Routes>
    );
};

export default SettingsRoutes;
